import { gsap } from 'gsap';
import { initGrid } from './utils/dom.js';
import { initBarba } from './utils/barba.js';
import Header from './components/header.js';

window.onbeforeunload = () => {
	document.body.style.opacity = 0;
	window.scrollTo(0, 0);
};

// Preserve GSAP state before bfcache freeze
window.addEventListener('pagehide', (event) => {
	if (event.persisted) {
		gsap.globalTimeline.pause();
	}
});

// Restore GSAP state from bfcache
window.addEventListener('pageshow', (event) => {
	document.body.style.opacity = '';
	if (event.persisted) {
		gsap.globalTimeline.resume();
	}
});

window.addEventListener('load', () => {
	initBarba();
	initGrid();
	window.headerInstance = new Header();
	document.addEventListener('dblclick', (e) => e.preventDefault());
	document.addEventListener('contextmenu', (e) => e.preventDefault());
});